// Rotas abertas pelo link enviado ao cliente: ficha e selfie (a rota real usa "acess", com um "c")
export const CUSTOMER_FORM_EXTERNAL_ACCESS_PATH = '/customers/external-acess/';

export const EXTERNAL_ACCESS_SESSION_EXPIRED_MESSAGE =
  'Sua sessão expirou. Para continuar o cadastro, abra de novo o link enviado ao seu e-mail. (Ref.: HTTP-401)';

export const EXISTING_PARTNER_LINKED_NOTICE =
  'Este sócio já tem cadastro no sistema e será vinculado. Os dados dele não aparecem aqui por segurança.';
